import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UUID} from 'app/utils/uuid';
import {environment} from 'environments/environment';
import {catchError, map, Observable, throwError} from 'rxjs';
import {ReferenceSummaryRow} from './types/reference-summary-row';

@Injectable({
  providedIn: 'root',
})
export class ReferenceSummaryService {
  private readonly _baseUrl: string = `${environment.apiHost}/reference-summary`;

  constructor(private _http: HttpClient) {}

  /**
   * Gets the reference summary for a given document.
   *
   * @param documentId The documentId to get reference summary for.
   * @returns An observable of the reference summary.
   */
  public fetchReferenceSummaryForDocument(sourceDocumentId: UUID): Observable<ReferenceSummaryRow[]> {
    const params = {
      sourceDocumentId: sourceDocumentId.value,
    };
    return this._http.get<any[]>(this._baseUrl, {params}).pipe(
      map((json: any) => json.map((j) => ReferenceSummaryRow.deserialise(j) as ReferenceSummaryRow)),
      catchError((response) => {
        return throwError(response);
      })
    );
  }
}
